import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from '../../../environments';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  private _creatingInvoice: BehaviorSubject<boolean>;

  constructor(private http: HttpClient) {
    this._creatingInvoice = new BehaviorSubject<boolean>(false);
  }

  get creatingInvoice$() {
    return this._creatingInvoice.asObservable();
  }

  postProcessorInvoice() {
    this._creatingInvoice.next(true);
    return this.http.post(`${environment.apiBaseUrl}/processor2-post-processor-invoice`, {}).pipe(
      finalize(() => {
        this._creatingInvoice.next(false);
      })
    );
  }
}
